// import { useDividas } from "../../../../../context/DividasContext";
import { useFila } from "../../../../../context/FilaContext";
import { formatCPFCNPJ } from "../../../../../utils/formatCPFCNPJ";

export const ClienteInfo = () => {
  // const { devedorCadastro } = useDividas()
  const { devedorFilaSelected } = useFila()
  return (
    <div className="my-4 flex w-full items-center gap-8 ">
      <p>
        <strong className="font-medium text-gray-800">Nome: </strong> {devedorFilaSelected?.name && devedorFilaSelected?.name.toUpperCase()}
      </p>
      <p>
        <strong className="font-medium text-gray-800">CPF/CNPJ: </strong>
        {devedorFilaSelected?.cpf_cnpj && formatCPFCNPJ(devedorFilaSelected?.cpf_cnpj)}
      </p>
    </div>
  );
};
